import React from "react";
import SignalStorageBattery from "../../ontario/signalStorageBattery";
const BatteryCardReports = (props) => {
  let batteryReports = [];
  props.reportData &&
    props.reportData.map((testForm) => {
      let tableData = testForm.formData.find((field) => field && field.type === "table");
      let eqDataArray = testForm.childForms && testForm.childForms.length > 0 ? testForm.childForms : [];
      let tableDataArray = tableData && tableData.value.length > 0 ? tableData.value : [];
      let dataArray = [...tableDataArray, ...eqDataArray];
      if (dataArray && dataArray.length > 0) {
        let dateObj = { date: testForm.date };
        if (testForm.backdate && testForm.backdate.originalDate) dateObj["entryDate"] = testForm.backdate.originalDate;
        for (let formCont of dataArray) {
          if (!formCont.removed && formCont.form) {
            let modelVal = formCont.form.find((field) => field && field.id === "circ");
            //equipment case
            if (formCont.equipment && formCont.equipment.id) {
              modelVal = { value: formCont.equipment.id };
            }
            if (modelVal) {
              let formObj = { ...formCont, ...dateObj };
              let mIndex = batteryReports.findIndex((bat) => bat.model === modelVal.value);
              if (mIndex > -1) {
                !batteryReports[mIndex].value && (batteryReports[mIndex].value = []);
                batteryReports[mIndex].value.push(formObj);
              } else {
                batteryReports.push({ value: [formObj], model: modelVal.value });
              }
            }
          }
        }
      }
    });
  let batReports = batteryReports.map((batteryReport, index) => {
    return (
      <SignalStorageBattery
        key={"batCard" + index}
        testData={batteryReport.value}
        name={""}
        formData={"form"}
        selectedAsset={props.selectedAsset}
      />
    );
  });
  return batReports;
};

export default BatteryCardReports;



// WEBPACK FOOTER //
// ./src/components/Reports/sims/FRA_Crossing/BatteryCardReport/BatteryCardReports.jsx